import { render, staticRenderFns } from "./FintechInfoRow.vue?vue&type=template&id=c13c1696&"
import script from "./FintechInfoRow.vue?vue&type=script&lang=js&"
export * from "./FintechInfoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports